<template>
  <Modal v-if="showModalAllFeedback" @close="$emit('closeModal')">
    <div class="allFeedback">
      <div class="allFeedback__header">
        <span class="allFeedback-title">
          {{ $t('allFeedback') }} {{ selectedKey }} {{ $t('reaction') }}
        </span>
        <img
          src="@/assets/icons/CloseModal.svg"
          alt=""
          @click="$emit('closeModal')"
        />
      </div>
      <div class="allFeedback__body">
        <div v-for="(el, index) in feedback" :key="index" class="feedback">
          <img
            class="item-img"
            :src="
              require(`@/assets/icons/${getLabel()[commentKey]}Pressed.png`)
            "
            alt=""
          />
          <div>
            <span class="text">{{ el.value }} </span>
          </div>
        </div>
        <div v-if="!feedback.length">
          <p>{{ $t('noFeedback') }}</p>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script lang="ts">
import moment from 'moment';
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'AllFeedback',
  props: ['showModalAllFeedback', 'feedback', 'selectedKey', 'commentKey'],
  methods: {
    dateTime(value: number) {
      if (value) {
        return moment(value).format('DD.MM.YYYY HH:mm');
      }
    },
    getLabel() {
      const labelsMap: Record<string, unknown> = {
        GOOD: 'Happy',
        OK: 'Ok',
        BAD: 'Angry'
      };

      return labelsMap;
    }
  }
})
export default class AllFeedback extends Vue {}
</script>

<style lang="scss">
.allFeedback {
  width: 460px;
  height: 100%;
  padding: 24px;
  .allFeedback__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .allFeedback-title {
      font-family: 'Ubuntu-Medium';
      font-size: $eighteenSize;
      line-height: $fifteenSize;
    }
    img {
      cursor: pointer;
    }
  }
  .allFeedback__body {
    overflow: auto;
    max-height: 400px;
    height: 100%;
    margin-top: 24px;
    .feedback {
      display: flex;
      align-items: center;
      border: 1px solid $border;
      padding: 12px;
      border-radius: 4px;
      margin-bottom: 12px;
      img {
        width: 35px;
        height: 40px;
        margin-right: 20px;
      }
      .text {
        color: $lineColor;
        font-size: $fifteenSize;
        margin-right: 12px;
      }
    }
  }
}
</style>
